module.exports = __webpack_public_path__ + "static/media/hotel11.b52871f2.png";